// extracted by mini-css-extract-plugin
module.exports = {"section":"CategoryLandingPageList_section__DNN5U","category-card-group":"CategoryLandingPageList_category-card-group__hi_gg","divider":"CategoryLandingPageList_divider__ni2YJ"};